import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import CompanyHistoryAndValues from "./sections/CompanyHistoryAndValues";
import TeamOverview from "./sections/TeamOverview";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Hero />
      <CompanyHistoryAndValues />
      <TeamOverview />
      <Footer />
    </div>;
}